<template>
  <div class="container container-fluid card my-4">
    <!-- EN TODOS LOS COMPONENTES (SPINERS Y ERRORES) --> 
    <div v-if="loading" class="spinner-container container-fluid">
      <div class="text-center pt-4">
        <h5>EDITAR EMPRESA</h5>
      </div> 
      <Loading-Style/>
    </div>

    <div v-if="!loading" class="container">
      <div v-if="errors.length">
        <div class="text-center pt-4">
          <h5>EDITAR USUARIO</h5>
        </div>
        <p class="alert alert-danger text-center">
          <ul>
            <li v-for="error in errors" :key="error.mensaje">{{ error.mensaje }}</li>
          </ul>
        </p>
      </div>

      <div class="container">
        <!-- Componente Principal -->
          <div v-if="!errors.length && mostrarComponentPrincipal" :key="1">
            <DataMain
              @datosPrincipales="updateDatosPrincipalesComponentes"
              :datosCompany="datosCompany"
            />
          </div>
        

        <div>
          <button
            v-if="datosPrincipales.logo && !hayFormulario1"
            @click="onNewForm1('FormEditCompanyPrimary')"
            class="btn btn-secondary my-4"
          >
          Agregar Formulario
          </button>
        </div>

        <ul class="nav nav-tabs">
          <div v-if="mostrarForm1">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ 'active': componentForm === 'FormEditCompanyPrimary' }"
                @click="showComponent('FormEditCompanyPrimary')"
              > 
              <div class="tab-content">
                <span>Formulario 1</span>
              </div>
              </button>
            </li>

          </div>
          <div v-if="hayFormulario1 && !hayFormulario2">
            <li class="nav-item">
              <button
                title="Crear otro Formulario"
                class="nav-link"
                @click="onNewForm2('FormEditCompanySecondary')"
              > 
              <span> + </span>
            </button>
            </li>
          </div>
          <div v-if="mostrarForm2">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ 'active': componentForm === 'FormEditCompanySecondary' }"
                @click.prevent="onNewForm2('FormEditCompanySecondary')"
              > 
              <div class="tab-content">
                <span>Formulario 2</span>
                <span @click.stop="eliminarFormulario('FormEditCompanySecondary')" class="btn-close" aria-label="Cerrar"></span>
              </div>
              </button>
            </li>
          </div>
          <div v-if="hayFormulario2 && !hayFormulario3">
            <li class="nav-item">
              <button
                title="Crear otro Formulario"
                class="nav-link"
                @click="onNewForm3('FormEditCompanyTertiary')"
              > 
              <span> + </span>
            </button>
            </li>
          </div>
          <div v-if="mostrarForm3">
            <li class="nav-item">
              <button
                class="nav-link"
                :class="{ 'active': componentForm === 'FormEditCompanyTertiary' }"
                @click="showComponent('FormEditCompanyTertiary')"
              > 
              <div class="tab-content">
                <span>Formulario 3</span>
                <span @click.stop="eliminarFormulario('FormEditCompanyTertiary')" class="btn-close" aria-label="Cerrar"></span>
              </div>
              </button>
            </li>
          </div>
        </ul>

        <!-- Componentes Secundarios - Formulario 1 -->
        <div v-show="mostrarForm1 && (componentForm === 'FormEditCompanyPrimary' || !hayFormulario1)">
          <FormEditCompanyPrimary
            @formData1="updateDatosForm1"
            :datosCompanyForm0="datosCompanyForm0"
          />
        </div>
        <!-- Componentes Secundarios - Formulario 2 -->
        <div v-show="mostrarForm2 && (componentForm === 'FormEditCompanySecondary' || !hayFormulario2)">
          <FormEditCompanySecondary
            @formData2="updateDatosForm2"
            :datosCompanyForm1="datosCompanyForm1"
          />
        </div>
        <!-- Componentes Secundarios - Formulario 3 -->
        <div v-show="mostrarForm3 && (componentForm === 'FormEditCompanyTertiary' || !hayFormulario3)">
          <FormEditCompanyTertiary
            @formData3="updateDatosForm3"
            :datosCompanyForm2="datosCompanyForm2"
          />
        </div>

        <div class="form-group d-grid gap-2 my-3">
          <button v-if="hayFormulario1 && mostrarGuardar" @click="saveFormData" class="btn btn-block btn-custom">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

  
<script>
  import { ref, onMounted } from 'vue'
  import apiAdmin from '../../apis/Admin'
  import DataMain from '../companies/edit/DataMain'
  import FormEditCompanyPrimary from './edit/FormEditCompanyPrimary';
  import FormEditCompanySecondary from './edit/FormEditCompanySecondary';
  import FormEditCompanyTertiary from './edit/FormEditCompanyTertiary';

  import { sharedState } from '../../Utils/StoreAsignacion';
  import { handleError, handleSweetInfo } from '../../Utils/StatusHandler';
  import { showSpinner, closeSpinner } from '../../Utils/AlertHandler';
    

  export default {
    name: 'CreateCompany',
    components: {
      DataMain,
      FormEditCompanyPrimary,
      FormEditCompanySecondary,
      FormEditCompanyTertiary
    },
    setup() {
      const loading = ref(true);

      const id = ref('');
      const mostrarComponentPrincipal = ref(false);
      const componentForm = ref(false);
      const mostrarForm1 = ref(false);
      const mostrarForm2 = ref(false);
      const mostrarForm3 = ref(false);
      const mostrarGuardar = ref(false);

      const companyId = ref(null);
      const datosPrincipales = ref([]);
      const datosSecundariosForm1 = ref([]);
      const datosSecundariosForm2 = ref([]);
      const datosSecundariosForm3 = ref([]);

      const errors = ref([]);
      const alert = ref([]);

      const companyName = ref(null);
      const emails = ref(null);
      const optionalEmails = ref([]);
      const logo = ref(null);

      const hayFormulario1 = ref(false);
      const hayFormulario2 = ref(false);
      const hayFormulario3 = ref(false);


      const datosCompany = ref([]);
      const datosCompanyForm0 = ref([]);
      const datosCompanyForm1 = ref([]);
      const datosCompanyForm2 = ref([]);
      
      
      const loadingComponentPersonal = sharedState.loadingComponentPersonal;

      const handleErrors = (error) => {
        handleError(error, { errors });
      };

      const handleSweetAlert = (info) => {
        handleSweetInfo(info, { alert });
      };

      const showComponent = (component) => {
        componentForm.value = component;
      }

      const updateDatosPrincipalesComponentes = (dataMain) => {
        datosPrincipales.value = dataMain;
        emails.value = dataMain.email;
      };

      const updateDatosForm1 = (dataForm) => {
        console.log('llega de hijo 1: ', dataForm);
        datosSecundariosForm1.value = dataForm.formData;
        if (datosSecundariosForm1.value) {
          mostrarGuardar.value = datosSecundariosForm1.value.formName.length >= 6;
        }
      };

      const updateDatosForm2 = (dataForm) => {
        datosSecundariosForm2.value = dataForm.formData;
      };

      const updateDatosForm3 = (dataForm) => {
        datosSecundariosForm3.value = dataForm.formData;
      };

      const datosCompanyInput = async () => {
        companyId.value = id.value;

        try {
          const response = await apiAdmin.postCompany(companyId.value);
          if (response) {
            datosCompany.value = response.data;

            datosCompanyForm0.value = response.data.companiesForms[0];
            if (datosCompanyForm0.value) {
              hayFormulario1.value = true;
              componentForm.value = 'FormEditCompanyPrimary';
              mostrarForm1.value = true;
            }
            if (datosCompany.value.companiesForms[1]) {
              datosCompanyForm1.value = response.data.companiesForms[1];
              hayFormulario2.value = true;
              componentForm.value = 'FormEditCompanySecondary';
              mostrarForm2.value = true;
              
            }
            if (datosCompany.value.companiesForms[2]) {
              datosCompanyForm2.value = response.data.companiesForms[2];
              hayFormulario3.value = true;
              componentForm.value = 'FormEditCompanyTertiary';
              mostrarForm3.value = true;
            }
          } else {
            console.error('No se encontraron datos en la respuesta.');
          }
        } catch (error) {
          handleErrors(error);
          console.error(error);
        } finally {
          loading.value = false;
          mostrarComponentPrincipal.value = true;
        }
      };

      const saveFormData = async () => {

        try {
          showSpinner();
          const optionalEmailsArray = Array.isArray(datosPrincipales.value.optionalEmails)
            ? datosPrincipales.value.optionalEmails
            : [];
          const allEmails = [emails.value, ...optionalEmailsArray];

          const formData = new FormData();
          formData.append('company_id', companyId.value);
          formData.append('name', datosPrincipales.value.name);
          formData.append('emails', allEmails);
          formData.append('images', datosPrincipales.value.logo);

          if (hayFormulario1.value) {
            const formData1 = datosSecundariosForm1.value;
            formData.append('formulario1', JSON.stringify(formData1));
          }

          if (hayFormulario2.value) {
            const formData2 = datosSecundariosForm2.value;
            formData.append('formulario2', JSON.stringify(formData2));
          }

          if (hayFormulario3.value) {
            const formData3 = datosSecundariosForm3.value;
            formData.append('formulario3', JSON.stringify(formData3));
          }

          const response = await apiAdmin.putUpdateCompany(companyId.value,formData);

          if (response) {
            closeSpinner();
            handleSweetAlert(response);
          }
        } catch (error) {
          console.error(error);
          closeSpinner();
          handleErrors(error);
        }
      };

      const onNewForm1 = (newComponent) => {
        hayFormulario1.value = true;
        componentForm.value = newComponent;
        mostrarForm1.value = true;
      };

      const onNewForm2 = (newComponent) => {
        hayFormulario2.value = true;
        componentForm.value = newComponent;
        mostrarForm2.value = true;
      };

      const onNewForm3 = (newComponent) => {
        hayFormulario3.value = true;
        componentForm.value = newComponent;
        mostrarForm3.value = true;
      };

      const eliminarFormulario = (componentForm) => {
        if (formularios[componentForm]) {
          formularios[componentForm].mostrar.value = false;
          formularios[componentForm].hay.value = false;
        }
      };

      const formularios = {
        'FormCreateCompanySecondary': { mostrar: mostrarForm2, hay: hayFormulario2 },
        'FormCreateCompanyTertiary': { mostrar: mostrarForm3, hay: hayFormulario3 }
      };

      onMounted(() => {
        datosCompanyInput();
      });

      return {
        loading,
        id,

        datosCompany,
        datosCompanyForm0,
        datosCompanyForm1,
        datosCompanyForm2,

        loadingComponentPersonal,

        mostrarComponentPrincipal,
        componentForm,
        mostrarForm1,
        mostrarForm2,
        mostrarForm3,
        mostrarGuardar,
        companyId,

        errors,
        alert,

        datosPrincipales,
        datosSecundariosForm1,
        datosSecundariosForm2,
        datosSecundariosForm3,

        companyName,
        emails,
        optionalEmails,
        logo,

        hayFormulario1,
        hayFormulario2,
        hayFormulario3,

        onNewForm1,
        onNewForm2,
        onNewForm3,
        eliminarFormulario,
        updateDatosPrincipalesComponentes,
        updateDatosForm1,
        updateDatosForm2,
        updateDatosForm3,
        saveFormData,
        showComponent

      };
    },
    created() {
      this.id = this.$route.params.id;
    },
  }
</script>